import ChevronLeft from "@geist-ui/react-icons/chevronLeft";
import ChevronRight from "@geist-ui/react-icons/chevronRight";
import Button from "@xtribe/shared/components/lib/Button";
import { useTeam } from "@xtribe/shared/hooks/useTeam";
import dayjs from "dayjs";
import "dayjs/locale/de";
import weekday from "dayjs/plugin/weekday";
import { useState } from "react";
import { useEvents } from "../../../hooks";
import { EventContentData } from "../../../hooks/useEvents/types";
import CalendarDate from "./CalendarDate";
import CalendarLesson from "./CalendarLesson";
dayjs.locale("de");
dayjs.extend(weekday);
type Props = {
  isWidget?: boolean;
};
const LivestreamCalendar: React.FC<Props> = ({ isWidget }) => {
  const { team, memberAccess, loading: teamLoading } = useTeam();
  const [week, setWeek] = useState({
    start: dayjs().weekday(0).hour(0).minute(0).second(0).millisecond(0).unix(),
    end: dayjs()
      .weekday(6)
      .hour(23)
      .minute(59)
      .second(59)
      .millisecond(999)
      .unix(),
  });
  const { data, error } = useEvents(
    {
      endDate: week.end,
      startDate: week.start,
      teamId: team?.id,
      preview: true,
      widget: isWidget,
    },
    { enabled: !!team?.id }
  );
  // const { data, error } = useSWR(() => url, fetcher);
  const dates = [0, 1, 2, 3, 4, 5, 6].map((el) => {
    const startDate = dayjs(week.start * 1000)
      .weekday(el)
      .toDate();
    const endDate = dayjs(week.start * 1000)
      .weekday(el)
      .hour(23)
      .minute(59)
      .second(59)
      .millisecond(999)
      .toDate();

    const lessons: EventContentData[] = [];
    if (!data) {
      return (
        <div className="w-full md:flex-1" key={startDate.getTime()}>
          <CalendarDate
            date={dayjs(week.start * 1000)
              .weekday(el)
              .toDate()}
            first={el === 0}
            last={el === 6}
            lessons={lessons.length}
          />
          <div className="py-2 lg:py-0 lg:px-0.5 -mx-1 flex flex-wrap">
            <div className="px-1 w-full my-1 sm:w-1/3 lg:w-full">
              <div className="skeleton-box h-32 w-full rounded-lg" />
            </div>
          </div>
        </div>
      );
    } else {
      data?.forEach((content) => {
        if (
          content.event?.startTime &&
          dayjs(content.event?.startTime * 1000).isAfter(startDate) &&
          dayjs(content.event?.startTime * 1000).isBefore(endDate)
        ) {
          lessons.push(content);
        }
      });
      return (
        <div className="w-full md:flex-1" key={startDate.getTime()}>
          <CalendarDate
            date={dayjs(week.start * 1000)
              .weekday(el)
              .toDate()}
            first={el === 0}
            last={el === 6}
            lessons={lessons.length}
          />
          <div className="py-2 lg:py-0 lg:px-0.5 -mx-1 flex flex-wrap">
            {lessons.map((el) => (
              <div className="px-1 w-full my-1 sm:w-1/3 lg:w-full" key={el.id}>
                <CalendarLesson content={el} isWidget={isWidget} />
              </div>
            ))}
          </div>
        </div>
      );
    }
  });
  const nextWeek = () => {
    setWeek((current) => ({
      start: dayjs(current.start * 1000)
        .add(7, "day")
        .unix(),
      end: dayjs(current.end * 1000)
        .add(7, "day")
        .unix(),
    }));
  };
  const previousWeek = () => {
    setWeek((current) => ({
      start: dayjs(current.start * 1000)
        .subtract(7, "day")
        .unix(),
      end: dayjs(current.end * 1000)
        .subtract(7, "day")
        .unix(),
    }));
  };
  return (
    <div>
      <div className="flex justify-between">
        <p className="font-medium text-lg sm:text-2xl">
          {dayjs(week.start * 1000).format("DD. MMM")} -{" "}
          {dayjs(week.end * 1000)
            .locale("de")
            .format("DD. MMM YYYY")}
        </p>
        <div className="flex">
          <Button iconButton icon={<ChevronLeft />} onClick={previousWeek} />
          <div className="w-4" />
          <Button
            iconButton
            icon={<ChevronRight />}
            type="success"
            onClick={nextWeek}
          />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row w-full mt-4">{dates}</div>
      {data && data.length === 0 && (
        <p className="py-12 text-center font-medium">
          In dieser Woche gibt es keine Kurse
        </p>
      )}
    </div>
  );
};

export default LivestreamCalendar;
